import { NgModule } from "@angular/core";
import { DatasourcePickerFormComponent } from './datasource-picker-form/datasource-picker-form.component';
import { DynamicDatasourcePickerComponent } from './dynamic-datasource-picker.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { DatasourceComponentsModule } from '../../datasource-components/datasource-components.module';
import { DatasourcePickerDesignComponent } from './datasource-picker-design/datasource-picker-design.component';
import { DatasourceFiltersDialogComponent } from './datasource-filters-dialog/datasource-filters-dialog.component';
import { DatasourceFiltersColumnsComponent } from './datasource-filters-columns/datasource-filters-columns.component';
import { MaterialModule } from '../../material.module';
import { DatasourceOrdersDialogComponent } from './datasource-orders-dialog/datasource-orders-dialog.component';
import { DatasourceParametersDialogComponent } from './datasource-parameters-dialog/datasource-parameters-dialog.component';
import { DatasourceParametersColumnsComponent } from './datasource-parameters-columns/datasource-parameters-columns.component';

@NgModule({
    declarations: [
        DatasourcePickerDesignComponent,
        DatasourcePickerFormComponent, 
        DynamicDatasourcePickerComponent,
        DatasourceFiltersDialogComponent,
        DatasourceFiltersColumnsComponent,
        DatasourceOrdersDialogComponent,
        DatasourceParametersDialogComponent,
        DatasourceParametersColumnsComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        MaterialModule,
        DatasourceComponentsModule
    ],
    entryComponents: [
        DynamicDatasourcePickerComponent,
        DatasourceFiltersDialogComponent,
        DatasourceOrdersDialogComponent,
        DatasourceParametersDialogComponent
    ],
    exports: [DatasourcePickerFormComponent]
})
export class DatasourcePickerModule {}